"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var MenuItem = function (_a) {
    var label = _a.label, onClick = _a.onClick, icon = _a.icon, isSelected = _a.isSelected;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('menu-item', { 'menu-item--selected': isSelected }), onClick: onClick },
        icon && react_1.default.createElement("span", { className: "menu-item-icon" }, icon),
        react_1.default.createElement("span", { className: "menu-item-label" }, label)));
};
var MenuGroup = function (_a) {
    var title = _a.title, items = _a.items, isExpanded = _a.isExpanded, isSelected = _a.isSelected, onClick = _a.onClick;
    return react_1.default.createElement("div", { className: (0, classnames_1.default)('menu-group', { 'menu-group--selected': isSelected }) },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('menu-group-title', {
                'menu-group-title--expanded': isExpanded,
                'menu-group-title--selected': isSelected,
            }), onClick: onClick }, title),
        isExpanded && (react_1.default.createElement("div", { className: "menu-group-items" }, items.map(function (item, index) { return (react_1.default.createElement(MenuItem, __assign({ key: index }, item))); }))));
};
var Menu = function (_a) {
    var items = _a.items;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    return react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-menu-container") }, items.map(function (item, index) { return (item.group ? (react_1.default.createElement(MenuGroup, __assign({ key: index }, item))) : (react_1.default.createElement(MenuItem, __assign({ key: index }, item)))); }));
};
exports.default = Menu;
//# sourceMappingURL=Menu.js.map